import React from 'react';
import { rem } from 'polished';
import moment from 'moment';
import styled from 'styled-components';
import { Loader } from 'oxyrion-ui/lib';
import { __, formatPrice, formatDate } from '../../../../Utils';
import { connect, actions } from '../../../../Store';
import BaseList from '../../BaseList';
import IconTd from '../../../../Components/ReusableComponents/IconTd';
import AlertPopup from '../../../../Components/AlertPopup';
import YearsSlider from '../../../../Components/YearsSlider';
import InvoicesGraph from '../../../../Components/InvoicesGraph';
import {
  ResponsiveFlexWrapper,
  PartWrapper,
  SliderWrapper,
  AnimatedFormMessageWrapper,
  InfoBox,
} from '../../../../Components/ReusableComponents';
import FileViewDownload from '../../../../Components/FileViewDownload';
import API2 from '../../../../API2';

const P = styled.p`
  margin: 0;
  padding: 0 ${rem(10)};
  font-size: ${rem(12)};
  height: ${rem(32)};
  display: flex;
  align-items: center;
`;

const Label = styled.div`
  font-weight: 700;
`;

const StyledPartWrapper = styled(PartWrapper)`
  overflow-y: scroll;
  order: 2;
  padding-top: ${rem(20)};
  ${({ theme }) => theme.media.m`
  width: 65%;
  order: unset;
  padding-top: 0;
  overflow: unset;
`};
`;

const IconWrapper = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const XMLWrapper = styled.div`
  width: 32px;
  height: 26px;
  align-items: center;
  display: flex;
  justify-content: center;
  border: 1px solid black;
  border-radius: 9px;
  font-size: 10px;
  font-weight: 800;
`;

const DownloadWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 90%;
  padding: 0 ${rem(10)};
`;

class ProductItems extends BaseList {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      actualYear: new Date().getFullYear(),
      title: __('Faktúry'),
      notFoundMessage: __('Ľutujeme faktúry sa nenašli'),
      isProduct: true,
      displayedColumns: {},
      months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      overduePriceTotal: {},
      paidPriceTotal: {},
      ordersPriceTotal: {},
      graphStats: [['data1'], ['data2'], ['data3']],
      defaultFilter: [
        {
          id: 'type',
          values: ['invoices'],
        },
      ],
    };

    actions.setActiveMenuItem('47');
  }

  componentDidMount() {
    this.init();
  }

  init() {
    const {
      actualPage,

      offset,
      nextOffset,
      total,
    } = this.loadActualData();

    let newCheckedFilter = [];

    if (!newCheckedFilter || newCheckedFilter.length === 0) {
      newCheckedFilter = this.state.defaultFilter;
    }

    this.setState(
      {
        loading: true,
        defaultSearchText: this.props.match.params.q,
        searchText: this.props.match.params.q,
        actualPage:
          actualPage &&
          actualPage !== null &&
          actualPage !== 'null' &&
          actualPage > 0
            ? Number(actualPage)
            : 1,
        offset:
          offset && offset !== null && offset !== 'null' && offset > 0
            ? Number(offset)
            : 0,
        nextOffset:
          nextOffset &&
          nextOffset !== null &&
          nextOffset !== 'null' &&
          nextOffset > 0
            ? Number(nextOffset)
            : 0,
        total:
          total && total !== null && total !== 'null' && total > 0
            ? Number(total)
            : 0,
        checkedFilter: [...newCheckedFilter],
      },
      async () => {
        await this.fetchFilter(
          !newCheckedFilter || newCheckedFilter.length === 0,
        );
        await this.fetchData();
        this.setTableHeight();
        this.saveActualData(1, 0, null, [], null);
      },
    );
  }

  async fetchData(parameters = {}) {
    try {
      const { searchText, actualYear, months } = this.state;
      this.setState({ showProductAddedPopup: false });
      const params = parameters;

      if (searchText && searchText.length > 0) {
        params.q = searchText;
      }

      if (actualYear) {
        params.year = actualYear;
      }

      const newData = await API2.getB2BInvoicesAction(params);

      console.log('newData---', newData);

      const { summary } = newData;

      const currency = this.props.user.firm === 'CZ' ? 'CZK' : 'EUR';

      const graphStats = [['data1'], ['data2'], ['data3']];

      months.forEach(m => {
        graphStats[0].push(
          summary.find(s => s.month === m) &&
            summary.find(s => s.month === m).total_price_vat &&
            summary.find(s => s.month === m).total_price_vat.amount
            ? summary.find(s => s.month === m).total_price_vat.amount
            : 0,
        );

        graphStats[1].push(
          summary.find(s => s.month === m) &&
            summary.find(s => s.month === m).paid &&
            summary.find(s => s.month === m).paid.amount
            ? summary.find(s => s.month === m).paid.amount
            : 0,
        );

        graphStats[2].push(
          summary.find(s => s.month === m) &&
            summary.find(s => s.month === m).not_paid_is_overdue &&
            summary.find(s => s.month === m).not_paid &&
            summary.find(s => s.month === m).not_paid.amount
            ? -summary.find(s => s.month === m).not_paid.amount
            : 0,
        );
      });

      const ordersPriceTotal = {
        amount: graphStats[0].reduce(
          (partialSum, a) => a !== 'data1' && partialSum + a,
          0,
        ),
        currency,
      };

      const paidPriceTotal = {
        amount: graphStats[1].reduce(
          (partialSum, a) => a !== 'data2' && partialSum + a,
          0,
        ),
        currency,
      };

      const overduePriceTotal = {
        amount: graphStats[2].reduce(
          (partialSum, a) => a !== 'data3' && partialSum + a * -1,
          0,
        ),
        currency,
      };

      this.setState({
        tableItems: newData.invoices,
        graphStats,
        ordersPriceTotal,
        paidPriceTotal,
        overduePriceTotal,
        loading: false,
        yearLoading: false,
        filtersDisabled: false,
        limit: newData.limit,
        offset: newData.offset,
        total: newData.total,
        nextOffset: newData.next_offset,
      });
      this.setState({ loading: false });
    } catch (e) {
      console.log(e);
      this.setState({ error: __('Nepodarilo sa faktúry') });
    }
  }

  handleSorter(s) {
    const { sorter } = this.state;
    let newSorter = sorter;
    switch (s) {
      case __('KÓD EAN'):
        if (sorter === 'Ean') {
          newSorter = '-Ean';
        } else {
          newSorter = 'Ean';
        }
        break;
      case __('PRODUKT'):
        if (sorter === 'Description') {
          newSorter = '-Description';
        } else {
          newSorter = 'Description';
        }
        break;
      case __('CENA'):
        if (sorter === 'Price') {
          newSorter = '-Price';
        } else {
          newSorter = 'Price';
        }
        break;
      default:
        newSorter = '';
        break;
    }

    this.setState({ sorter: newSorter }, () => this.fetchData());
  }

  async downloadXMLFile(id) {
    try {
      this.setState({
        downloadXmlLoadingId: id,
      });

      // const result = await API2.getB2BInvoiceXMLFileAction(id, {
      //   type: 'pohoda',
      // });
      // nepouziva sa uz

      this.setState({
        // downloadId: result.url,
        downloadXmlLoadingId: false,
      });
    } catch (e) {
      console.log(e);
    }
  }

  async downloadFileWithId(downloadId) {
    window.location.href = downloadId;

    this.setState({
      downloadId: undefined,
    });
  }

  setTableHeight() {
    if (this.pager && this.mainWrapper && this.segment) {
      const tableHeight = window.innerHeight - 600;

      this.setState({ tableHeight });
    }
  }

  createColumns(sorter) {
    const result = [
      {
        accessor: '_id',
        Header: () => (
          <IconTd sorter={sorter === 'No' || sorter === '-No' ? sorter : null}>
            {__('Číslo faktúry')}
          </IconTd>
        ),
        Cell: props => {
          return (
            <P onClick={() => this.onTdClicked(props.index)}>{props.value}</P>
          );
        },
      },
      {
        accessor: 'order_no',
        Header: () => (
          <IconTd sorter={sorter === 'No' || sorter === '-No' ? sorter : null}>
            {__('Číslo objednávky')}
          </IconTd>
        ),
        Cell: props => {
          return (
            <P onClick={() => this.onTdClicked(props.index)}>{props.value}</P>
          );
        },
      },
      {
        accessor: 'user_name',
        Header: () => (
          <IconTd sorter={sorter === 'No' || sorter === '-No' ? sorter : null}>
            {__('Predajca')}
          </IconTd>
        ),
        Cell: props => {
          return (
            <P onClick={() => this.onTdClicked(props.index)}>{props.value}</P>
          );
        },
      },
      {
        accessor: 'row_count',
        Header: () => (
          <IconTd sorter={sorter === 'No' || sorter === '-No' ? sorter : null}>
            {__('Počet položiek')}
          </IconTd>
        ),
        Cell: props => {
          return <P>{props.value}</P>;
        },
      },
      {
        accessor: 'price_vat',
        Header: () => (
          <IconTd sorter={sorter === 'No' || sorter === '-No' ? sorter : null}>
            {__('Cena s DPH')}
          </IconTd>
        ),
        Cell: props => {
          return (
            <P
              onClick={() => this.onTdClicked(props.index)}
              style={{
                color: this.getColor(
                  props.original.is_paid,
                  props.original.overdue,
                ),
              }}
            >
              {formatPrice(props.value)}
            </P>
          );
        },
      },
      {
        accessor: 'posting_date',
        Header: () => (
          <IconTd sorter={sorter === 'No' || sorter === '-No' ? sorter : null}>
            {__('Dátum vystavenia')}
          </IconTd>
        ),
        Cell: props => {
          return (
            <P onClick={() => this.onTdClicked(props.index)}>
              {formatDate(moment(props.value))}
            </P>
          );
        },
      },

      {
        accessor: 'due_date',
        Header: () => (
          <IconTd sorter={sorter === 'No' || sorter === '-No' ? sorter : null}>
            {__('Dátum splatnosti')}
          </IconTd>
        ),
        Cell: props => {
          return (
            <P onClick={() => this.onTdClicked(props.index)}>
              {formatDate(moment(props.value))}
            </P>
          );
        },
      },

      {
        accessor: '_id',
        Header: () => (
          <IconTd sorter={sorter === 'No' || sorter === '-No' ? sorter : null}>
            {__('Zobraziť / Stiahnuť')}
          </IconTd>
        ),
        maxWidth: 150,
        Cell: props => {
          return (
            <DownloadWrapper>
              <FileViewDownload
                name={props.value}
                history={this.props.history}
                downloadFunction={async () => {
                  return API2.getB2BInvoicePDFFileAction(props.value);
                }}
                error={error => {
                  this.setState({ error });
                }}
              />
            </DownloadWrapper>
          );
        },
      },

      {
        accessor: '_id',
        Header: () => (
          <IconTd sorter={sorter === 'No' || sorter === '-No' ? sorter : null}>
            {__('XML')}
          </IconTd>
        ),
        maxWidth: 50,
        Cell: props => {
          return (
            <P>
              <IconWrapper onClick={() => this.downloadXMLFile(props.value)}>
                {this.state.downloadXmlLoadingId === props.value ? (
                  <Loader />
                ) : (
                  <XMLWrapper>XML</XMLWrapper>
                )}
              </IconWrapper>
            </P>
          );
        },
      },
    ];

    return result;
  }

  getColor(paid, overdue) {
    if (paid) {
      return '#578a03';
    } else if (!paid && !overdue) {
      return 'black';
    } else if (!paid && overdue) {
      return 'red';
    }

    return '#6f6f6f';
  }

  onTdClicked(rowIndex) {
    const { tableItems } = this.state;
    if (tableItems[rowIndex]) {
      this.props.history.push(`../shop/invoices/${tableItems[rowIndex]._id}`);
    }
  }

  renderCustomContent() {
    const {
      customContentLoading,
      actualYear,
      yearLoading,
      graphStats,
      overduePriceTotal,
      paidPriceTotal,
      ordersPriceTotal,
    } = this.state;

    return (
      <AnimatedFormMessageWrapper display={!customContentLoading}>
        <ResponsiveFlexWrapper style={{ marginTop: rem(8) }}>
          <StyledPartWrapper width="65%">
            <InvoicesGraph
              header={`${__('Prehľad faktúr')} ${actualYear}`}
              data={graphStats}
              firm={this.props.user.firm}
              loading={customContentLoading}
            />
          </StyledPartWrapper>
          <PartWrapper width="35%">
            <SliderWrapper>
              <YearsSlider
                loading={yearLoading}
                onClick={side => {
                  this.handleYearChange(side);
                }}
                selectedYear={actualYear}
              />
            </SliderWrapper>
            <InfoBox>
              <Label> {__('Vystavené FA')} </Label>
              {formatPrice(ordersPriceTotal)}
            </InfoBox>

            <InfoBox>
              <Label> {__('Zaplatené FA')} </Label>
              {formatPrice(paidPriceTotal)}
            </InfoBox>

            <InfoBox>
              <Label> {__('FA po splatnosti')} </Label>
              {formatPrice(overduePriceTotal)}
            </InfoBox>
          </PartWrapper>
        </ResponsiveFlexWrapper>
      </AnimatedFormMessageWrapper>
    );
  }

  handleYearChange(side) {
    let { actualYear } = this.state;
    if (side === 'right') {
      if (actualYear + 1 > new Date().getFullYear()) {
        return;
      }
      actualYear += 1;
    } else {
      actualYear -= 1;
    }

    this.setState(
      {
        yearLoading: true,
        actualYear,
      },
      () => this.fetchData(),
    );
  }

  render() {
    const { downloadId } = this.state;

    return (
      <React.Fragment>
        <AlertPopup
          alignUnderHeader
          display={downloadId}
          style
          onClose={() =>
            this.setState({
              downloadId: undefined,
            })
          }
          scrollContent
          question
          text={__(`Prajete si uložiť súbor`)}
          onSubmit={() => this.downloadFileWithId(downloadId)}
          onDismiss={() =>
            this.setState({
              downloadId: undefined,
            })
          }
        />
        {super.render()}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(ProductItems);



// WEBPACK FOOTER //
// ./src/Containers/Shop/Invoices/List/index.jsx